import React, { ReactElement } from "react";
import classNames from "classnames";
import { MessageRole } from "./message.types";
import { MessagePanelProps } from "./message-panel.types";

const MessagePanel = ({
  animate = false,
  className,
  children,
  role,
  ariaLabel,
  ariaLabelledBy,
}: MessagePanelProps): ReactElement => {
  const classes = classNames(
    "spark-panel",
    "spark-message-panel",
    {
      "spark-message--animate": animate,
    },
    className
  );

  if (
    role === MessageRole.REGION &&
    (ariaLabel || ariaLabelledBy) === undefined
  ) {
    console.warn(
      `ariaLabel or ariaLabelledBy prop is required when ARIA role is "region"`
    );
  }

  interface ariaPropsType {
    "aria-label"?: string;
    "aria-labelledby"?: string;
  }

  const ariaProps: ariaPropsType = {};

  if (ariaLabel) {
    ariaProps["aria-label"] = ariaLabel;
  } else if (ariaLabelledBy) {
    ariaProps["aria-labelledby"] = ariaLabelledBy;
  }

  return (
    <div className={classes} role={role} {...ariaProps}>
      {children}
    </div>
  );
};

MessagePanel.displayName = "MessagePanel";

export { MessagePanel };
